// extracted by mini-css-extract-plugin
export var searchHeader = "_9m-0";
export var searchHeaderDark = "_9m-1";